
import {
  computed,
  ComputedRef,
  defineComponent,
  onBeforeMount,
  ref
} from "vue";
import {
  EventClass,
  EventCourse
} from "../../../../../domain/entities/courseEvent/courseEvent";
import { wrapLoading } from "../../../utils/wrap_loading";
import { dispatchError } from "../../../utils/error_handling";
import { useStore } from "vuex";
import {
  Menu,
  TrainingCourseRequest
} from "../../../../../domain/entities/courseEvent/training_course";
import {
  dispatchErrorBox,
  dispatchSuccessBox,
  formatHour,
  formatMenusDates,
  formatMenusSchedule,
  formattedDate,
  formattedDuration,
  getLocalFormatDate
} from "../../mixins";
import TrainingTableOption from "../../../views/course/TrainingTableOption.vue";
import TUIViewer from "../TUIViewer.vue";
import { User } from "../../../../../domain/entities/entities";

const __default__ = defineComponent({
  name: "ModalData",
  components: { TUIViewer, TrainingTableOption },
  methods: {
    formattedDate,
    getLocalFormatDate,
    formattedDuration,
    formatMenusDates,
    formatMenusSchedule
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    type: {
      type: Number,
      required: true
    },
    selectedClass: {
      type: Number,
      required: false
    }
  },
  setup(props) {
    const localUser = localStorage.getItem("user");

    class ModalData {
      name: string = "";
      description: string = "";
      hasCertificate: boolean = false;
      image: string = "";
      isActive: boolean = false;
      activationDate: string = "";
      inactivationDate: string = "";
      isAttendance: boolean = false;
      usersCount: number = 1;
      maxCapacity: number = 1;
      date: string = "";
      location: string = "";
      schedule: string = "";
      duration: number = 0;
      menus: Array<Menu> = [new Menu()];
      user: User = new User();
      class: EventClass = new EventClass();
    }

    enum ContentType {
      EVENT = 1,
      GRADUATION = 2
    }

    const data = ref<ModalData>(new ModalData());
    const modalImage = ref<string>("");
    const hasMenu = ref<boolean>(false);
    const store = useStore();

    const userEvent: ComputedRef<EventCourse> = computed(
      () => store.getters["userProfile_module/userActiveEvent"]
    );

    const userTraining: ComputedRef<TrainingCourseRequest> = computed(
      () => store.getters["userProfile_module/userActiveTraining"]
    );

    const loadUserData = async (type: number, id: number): Promise<void> => {
      const dispatchMap = {
        1: "userProfile_module/loadUserActiveEvent",
        2: "userProfile_module/loadUserActiveTraining"
      };

      try {
        await wrapLoading(async () => {
          await store.dispatch(dispatchMap[type], id);
        });
      } catch (e) {
        await dispatchError(e);
      }
    };

    const setUserTrainingData = (training: TrainingCourseRequest) => {
      modalImage.value = `url(${training.graduation.imageURL})`;
      hasMenu.value = true;

      data.value.name = training.graduation.title;
      data.value.description = training.graduation.description;
      data.value.hasCertificate = training.graduation.haveCertification;
      data.value.isActive = training.graduation.isActive;
      data.value.activationDate = training.graduation.activationDate;
      data.value.inactivationDate = training.graduation.inactivationDate;
      data.value.usersCount = training.users.length;
      data.value.menus = training.graduation.menus;
      data.value.duration = training.graduation.duration;
      data.value.location = training.graduation.location;
      data.value.maxCapacity = training.graduation.maxCapacity;
    };

    const setUserEventData = (event: EventCourse) => {
      modalImage.value = `url(${event.image})`;

      data.value.name = event.name;
      data.value.description = event.description;
      data.value.isActive = event.isActive;
      data.value.activationDate = event.activationDate;
      data.value.inactivationDate = event.inactivationDate;
      data.value.date = event.classes[0].scheduleStart;

      data.value.usersCount = event.classes[0].enrollUsers.length;
      data.value.user = event.classes[0].enrollUsers[0];
      data.value.hasCertificate = event.classes[0].hasCertificate;
      data.value.duration = event.classes[0].duration;
      data.value.maxCapacity = event.classes[0].maxCapacity;
      data.value.location = event.classes[0].location;
      data.value.class = event.classes[0];

      //todo necessita do classid para preencher abaixo precisa saber quem eu sou
      data.value.isAttendance = true;
    };

    const formatMenus = (
      index: number,
      startDate: string,
      duration: number,
      startHour: string,
      endHour: string
    ): string => {
      if (!startHour || !endHour)
        return `${index + 1}° dia: ${getLocalFormatDate(startDate)}
        - ${formattedDuration(duration)}`;

      return `${index + 1}° dia: ${getLocalFormatDate(startDate)}
       - Início: ${formatHour(startHour)}, Fim: ${formatHour(endHour)}`;
    };

    onBeforeMount(async () => {
      if (!props.id) return;

      await loadUserData(props.type, props.id);

      if (props.type === ContentType.GRADUATION)
        return setUserTrainingData(userTraining.value);

      setUserEventData(userEvent.value);
    });

    async function unEnrollUser() {
      try {
        await store.dispatch("event_module/unEnrollUser", {
          user: localUser,
          eventClass: data.value.class
        });
        await dispatchSuccessBox("Inscrição cancelada com sucesso!");
      } catch (e) {
        await dispatchErrorBox(e);
      }
    }

    return {
      modalImage,
      data,
      formatMenus,
      unEnrollUser,
      hasMenu,
      ...ContentType
    };
  }
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "f5490e48": (_ctx.modalImage)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__